import React from 'react';
import _ from 'lodash';
import i18next from 'i18next';
import { useFormContext } from 'react-hook-form';
import CalculatorMultipleSelectInput from '../../../calculatorInputs/CalculatorMultipleSelectInput';
import CalculatorMultipleValueInput from '../../../calculatorInputs/CalculatorMultipleValueInput';

const SetValue = ({ fieldName, showLabel, availableValueOptions, readOnly = false }) => {
  const { setError, clearErrors } = useFormContext();

  const validateValue = (value) => {
    if (!value || value.length === 0) {
      setError(fieldName, {
        type: 'manual',
        message: i18next.t('calculator.errors.criterionValueEmpty'),
      });
      return false;
    } else {
      clearErrors(fieldName);
      return true;
    }
  };

  const commonProps = {
    fieldName,
    isRequired: true,
    label: showLabel ? i18next.t('calculator.dialog.create.label.values') : '',
    placeholder: i18next.t('calculator.dialog.create.placeholder.selectValues'),
    uxVariant: 'criteriaInput',
    validate: validateValue,
  };

  return !_.isEmpty(availableValueOptions) ? (
    <CalculatorMultipleSelectInput
      {...commonProps}
      options={availableValueOptions}
      variant="standard"
      triggerOnContinue
      disabled={readOnly}
    />
  ) : (
    <CalculatorMultipleValueInput {...commonProps} disabled={readOnly}/>
  );
};

export default SetValue;
